<template>
  <div class="login">
    <b-form class="login__form" @keypress.enter.prevent="sendData">
      <b-form-group label="Логин">
        <b-form-input type="text" v-model="login" />
      </b-form-group>
      <b-form-group label="Пароль">
        <b-form-input type="password" v-model="password" />
      </b-form-group>
      <b-button variant="success" block @click="sendData">Вход</b-button>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  mixins: [pageTitleMixin],
  data() {
    return {
      login: "",
      password: ""
    };
  },
  computed: {
    ...mapGetters("user", ["hasRole"])
  },
  methods: {
    sendData() {
      let { login, password } = this;
      this.$store.dispatch("user/logIn", { login, password }).then(() => {
        let nextRoute = "";
        if (this.hasRole(["root", "admin"])) nextRoute = "/";
        else if (this.hasRole(["gymAdder", "gymManager"])) nextRoute = "/gyms";
        this.$router.push(nextRoute);
      });
    }
  }
};
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  &__form {
    padding: 10px;
    background: white;
    border-radius: 0.3rem;
    width: 90%;
    max-width: 600px;
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
  }
}
</style>
